<template>
  <div class="full-100">
    <div v-if="slotCode === 'JOKER'">
      <joker :url="url" :account="account" :trigger="trigger"></joker>
    </div>
    <div v-else-if="slotCode === 'SEXYGAME'">
      <sexygame :url="url" :account="account" :trigger="trigger"></sexygame>
    </div>
    <div v-else-if="slotCode === 'BETFLIX'">
      <betflix :url="url" :account="account" :trigger="trigger"></betflix>
    </div>
    <div v-else-if="slotCode === 'ASKMEBET'">
      <askmebet :url="url" :account="account" :trigger="trigger"></askmebet>
    </div>
    <div v-else-if="slotCode === 'UFABET'">
      <ufabet :url="url" :account="account" :trigger="trigger"></ufabet>
    </div>
    <div v-else-if="slotCode === 'SUPERSLOT'">
      <superslot :url="url" :account="account" :trigger="trigger"></superslot>
    </div>
    <div v-else-if="slotCode === 'PG'">
      <pg :url="url" :account="account" :trigger="trigger"></pg>
    </div>
    <div v-else-if="slotCode === 'SLOTXO'">
      <slotxo :url="url" :account="account" :trigger="trigger"></slotxo>
    </div>
    <div v-else-if="slotCode === 'IMI'">
      <imi :url="url" :account="account" :trigger="trigger"></imi>
    </div>
    <div v-else-if="slotCode === 'USUN'">
      <usun :url="url" :account="account" :trigger="trigger"></usun>
    </div>
    <div v-else-if="slotCode === 'AREASLOT'">
      <areaslot :url="url" :account="account" :trigger="trigger"></areaslot>
    </div>
    <div v-else-if="slotCode === 'CIRCUS'">
      <circus :url="url" :account="account" :trigger="trigger"></circus>
    </div>
    <div v-else-if="slotCode === 'SLOTRACHA'">
      <slotracha :url="url" :account="account" :trigger="trigger"></slotracha>
    </div>
    <div v-else-if="slotCode === 'PGSLOT'">
      <pgslot :url="url" :account="account" :trigger="trigger"></pgslot>
    </div>
    <div v-else-if="slotCode === 'JOKER2'">
      <joker2 :url="url" :account="account" :trigger="trigger"></joker2>
    </div>
    <div v-else-if="slotCode === 'HUAYHD'">
      <huayhd :url="url" :account="account" :trigger="trigger"></huayhd>
    </div>
    <div v-else-if="slotCode === 'PGLAZ'">
      <pglaz :url="url" :account="account" :trigger="trigger"></pglaz>
    </div>
    <div v-else>
      <other :url="url" :trigger="trigger"></other>
    </div>
  </div>
</template>

<script>
import Joker from './slot/Joker'
import Sexygame from './slot/Sexygame'
import Betflix from './slot/Betflix'
import Askmebet from './slot/Askmebet'
import Ufabet from './slot/Ufabet'
import Superslot from './slot/Superslot'
import Pg from './slot/Pg'
import Slotxo from './slot/Slotxo'
import Imi from './slot/Imi'
import Usun from './slot/Usun'
import Areaslot from './slot/Areaslot'
import Circus from './slot/Circus'
import Slotracha from './slot/Slotracha'
import Pgslot from './slot/Pgslot'
import Joker2 from './slot/Joker2'
import Huayhd from './slot/Huayhd'
import Pglaz from './slot/Pglaz'
import Other from './slot/Other'

export default {
  name: 'LoginSlot',
  components: {
    Joker,
    Sexygame,
    Betflix,
    Askmebet,
    Ufabet,
    Superslot,
    Pg,
    Slotxo,
    Imi,
    Usun,
    Areaslot,
    Circus,
    Slotracha,
    Pgslot,
    Joker2,
    Huayhd,
    Pglaz,
    Other
  },
  props: {
    slotCode: {
      type: String
    },
    url: {
      type: String
    },
    account: {
      type: Object
    },
    trigger: {
      type: Number
    }
  }
}
</script>
